import React from 'react';
import { ClipboardCheck, ShieldCheck, FileCheck, CheckCircle } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for NACSA Checklist feature
 * Displays information about the NACSA Checklist feature and its benefits
 */
export const NacsaChecklistFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="NACSA Compliance Checklist"
      description="Track and demonstrate compliance with National Cyber Security Authority (NACSA) requirements and security best practices."
      icon={<ClipboardCheck className="h-8 w-8 text-blue-600" />}
      featureName="nacsa-checklist"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ClipboardCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Compliance Tracking</h3>
          </div>
          <p className="text-gray-400">
            Track compliance status across all NACSA requirements with detailed progress monitoring and documentation.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ShieldCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Controls</h3>
          </div>
          <p className="text-gray-400">
            Implement and verify security controls required by NACSA with step-by-step guidance and validation.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Evidence Collection</h3>
          </div>
          <p className="text-gray-400">
            Streamline compliance evidence collection and documentation for NACSA audits and regulatory requirements.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <CheckCircle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Gap Analysis</h3>
          </div>
          <p className="text-gray-400">
            Identify compliance gaps and security weaknesses with automated assessment tools and actionable recommendations.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
